import {AttributeDefinitionDto} from "../../../../../../common/apis/stereotype/AttributeDefinitionDto";
import {ElementDto} from "../../../../../../common/apis/element/ElementDto";
import {PropertyCreateDto, PropertyDto} from "../../../../../../common/apis/property/PropertyApi";
import {ElementService} from "../../../elementdetail/service/ElementService";
import {ValuePersister} from "./ValuePersister";
import {PropertyDefinitionIdConverter} from "../../../property/PropertyDefinitionIdConverter";


export class PropertyValuePersister implements ValuePersister {

    constructor(private readonly elementApiClient: ElementService) {}

    updateValue(element: ElementDto, attributeDefinition: AttributeDefinitionDto, value: string | null | undefined): Promise<void> {
        const existingProperty = this.findPropertyByAttributeDef(element, attributeDefinition);
        if (value === null || value === undefined) {
            if (existingProperty) {
                return this.elementApiClient.deleteProperty(element.identifier, existingProperty.definition.identifier);
            } else {
                return Promise.resolve();
            }
        } else {
            if (existingProperty) {
                return this.elementApiClient.updateProperty(element.identifier, existingProperty.definition.identifier, value);
            } else {
                const propertyCreate: PropertyCreateDto = {
                    propDefIdentifier: PropertyDefinitionIdConverter.convertToPropDefId(attributeDefinition.id),
                    name: attributeDefinition.name,
                    type: attributeDefinition.dataType.coreDataType,
                    value: value
                };
                return this.elementApiClient.createProperty(element.identifier, propertyCreate)
                        .then(() => {});
            }
        }
    }

    private findPropertyByAttributeDef(element: ElementDto, attrDef: AttributeDefinitionDto): PropertyDto | undefined {
        return element.properties?.find(prop => this.matchesAttributeDefinition(prop, attrDef));
    }

    private matchesAttributeDefinition(prop: PropertyDto, attrDef: AttributeDefinitionDto): boolean {
        return prop.definition.identifier === PropertyDefinitionIdConverter.convertToPropDefId(attrDef.id) || prop.definition.name === attrDef.name;
    }
}